var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMolotov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "29px",
    height: "40px",
    viewBox: "0.137 0 29 40",
    enableBackground: "new 0.137 0 29 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.592,12.281c-0.081,0.191-0.014,0.423,0.205,0.696c0.19,0.273,0.137,0.64-0.164,1.104l-1.311,1.555 c-0.307,0.353-0.747,0.574-1.302,0.678l0.374-0.611l0.188-0.039L23,13.726l-0.271-0.709l-0.984-0.939 c-0.386-0.265-0.733-0.453-1.062-0.572l-0.859-0.075l-1.342,1.833l-0.364,0.553h0.151L17.36,14.92l-0.521-1.042 c-0.217-0.737-0.259-1.336-0.122-1.801l0.491-0.899c0.189-0.381,0.189-0.9,0-1.555l0.451,0.165c0.354,0.19,0.613,0.491,0.775,0.9 l0.125,1.104l0.04,0.45l0.613-1.35c0.026-0.272-0.15-0.696-0.532-1.27l-0.899-1.145c-0.164-0.245-0.231-0.818-0.204-1.719 C17.604,5.833,17.74,5.246,17.987,5c0.054,0.573,0.299,1.077,0.734,1.514c0.22,0.219,0.806,0.464,1.761,0.737 c0.382,0.109,0.613,0.34,0.694,0.695l0.327,0.859l0.451,0.613c0.191,0.247,0.341,0.314,0.45,0.205c0.11-0.108,0-0.422-0.325-0.94 c-0.357-0.544-0.303-1.146,0.161-1.8c0.055,0.273,0.382,0.682,0.982,1.228c0.599,0.573,0.968,1.133,1.104,1.678l0.039,0.818 l-0.326,0.982L23.592,12.281z M21.382,15.351l1.229-1.677l-0.205-0.532l-0.859-0.777c-0.356-0.245-0.682-0.423-0.982-0.532 l-0.572-0.04l-1.227,1.676h0.04v0.246l-3.232,3.929l-0.735,0.49l-1.227,0.573c-1.229,0.573-2.046,1.159-2.455,1.759L4.034,30.488 c-0.108,0.272,0.042,0.735,0.452,1.391c0.462,0.71,1.078,1.337,1.84,1.882c0.766,0.545,1.506,0.911,2.374,1.145 c0.867,0.233,1.473-0.04,1.473-0.04l7.118-9.984c0.408-0.599,0.696-1.568,0.857-2.904c0.138-1.362,0.261-2.113,0.369-2.249 l2.659-4.337L21.382,15.351z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_11_1_",
    x: 28.367,
    fill: "none",
    width: 88,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_10_1_",
    fill: "none",
    width: 28.367,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolotov);
export default __webpack_public_path__ + "static/media/molotov.001b5952a131fc98e3f262b22f84ce08.svg";
export { ForwardRef as ReactComponent };